import { render, staticRenderFns } from "./BaseFooterColumn.vue?vue&type=template&id=2ae73842&"
import script from "./BaseFooterColumn.vue?vue&type=script&lang=ts&"
export * from "./BaseFooterColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports